import { render, staticRenderFns } from "./XTextField.vue?vue&type=template&id=20674b04&scoped=true"
import script from "./XTextField.vue?vue&type=script&lang=js"
export * from "./XTextField.vue?vue&type=script&lang=js"
import style0 from "./XTextField.vue?vue&type=style&index=0&id=20674b04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20674b04",
  null
  
)

export default component.exports